document.addEventListener('DOMContentLoaded', function () {
  const addToCartButtons = document.querySelectorAll('a[href$="/pages/buy-now"]');

  const variantId = 44242324750447;
  const quantityToAdd = 1;

  addToCartButtons.forEach(function (button) {
    button.addEventListener('click', async function (event) {
      event.preventDefault();

      try {
        const cart = await fetch('/cart.js').then(r => {
          if (!r.ok) throw new Error(`Failed to fetch cart: ${r.status}`);
          return r.json();
        });

        const alreadyInCart = cart.items.some(item => item.variant_id === variantId);
        const sectionId = getCartDrawerSectionId();
        const sectionsParam = sectionId ? [sectionId] : [];

        let payload;
        if (alreadyInCart) {
          payload = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: {}, sections: sectionsParam }),
          }).then(r => r.json());
        } else {
          payload = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: quantityToAdd }],
              sections: sectionsParam,
            }),
          }).then(async r => {
            const data = await r.json().catch(() => null);
            if (!r.ok) {
              throw new Error(`Failed to add item: ${r.status} ${r.statusText}. ${data ? JSON.stringify(data) : ''}`);
            }
            return data;
          });
        }

        const freshCart = await fetch('/cart.js').then(r => r.json());
        freshCart.sections = payload?.sections || {};

        if (window.FoxTheme?.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            sources: 'buy-now-button',
            cart: freshCart,
          });
        }

        openCart();
      } catch (error) {
        console.error('Error during cart operation:', error);
        alert(`Failed to update the cart: ${error.message}. Please try again.`);
      }
    });
  });
});

function getCartDrawerSectionId() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return null;
  const section = cartDrawer.closest('.shopify-section');
  return section ? section.id.replace('shopify-section-', '') : null;
}

function openCart() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  if (typeof cartDrawer.show === 'function') {
    cartDrawer.show();
    return;
  }

  cartDrawer.removeAttribute('hidden');
  cartDrawer.setAttribute('open', '');
  const overlay = cartDrawer.querySelector('.fixed-overlay');
  if (overlay) overlay.setAttribute('aria-expanded', 'true');
  document.body.classList.add('modal-show');
}
